/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioCreateRequest
 */
export interface PortfolioCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioCreateRequest
     */
    order: number;
}

/**
 * Check if a given object implements the PortfolioCreateRequest interface.
 */
export function instanceOfPortfolioCreateRequest(value: object): value is PortfolioCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function PortfolioCreateRequestFromJSON(json: any): PortfolioCreateRequest {
    return PortfolioCreateRequestFromJSONTyped(json, false);
}

export function PortfolioCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'order': json['order'],
    };
}

export function PortfolioCreateRequestToJSON(json: any): PortfolioCreateRequest {
    return PortfolioCreateRequestToJSONTyped(json, false);
}

export function PortfolioCreateRequestToJSONTyped(value?: PortfolioCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'order': value['order'],
    };
}

